.modalInner,
.modalOverlay {
    z-index: var(--mantine-priority-high);
}

.modalContent {
    border-radius: 16px;
    z-index: var(--mantine-priority-high);
    background-color: var(--mantine-color-dark-5);
    /* Solution until we solve for responsiveness */
    @media screen and (max-height: 768px) {
        max-height: 39.675rem;
    }
}

.modalTextareaContainer {
    background-color: var(--mantine-color-dark-7);
    border: 1px solid var(--mantine-color-dark-4);
    border-radius: 8px;
    &:focus-within {
        border-color: var(--mantine-color-asurion-5);
    }
    &:has(.modalTextarea:disabled) {
        background-color: color-mix(in srgb, var(--mantine-color-dark-4), transparent 70%);
        border: none;
    }
}

.modalTextarea {
    line-height: 1.5rem;
    color: var(--mantine-color-gray-4);
    background-color: transparent;
    border: none;
    font-size: var(--mantine-font-size-xs);

    &:disabled {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        color: var(--mantine-color-gray-4);
        background-color: transparent;
        padding-left: 3.5rem;
        overflow: hidden;
        -webkit-line-clamp: 5;
        line-clamp: 5;
        opacity: 1;
    }
}

.modalTextareaSection {
    align-items: flex-start;
    margin: 0.75rem;
}

.modalContainer {
    position: absolute;
    top: auto;
    gap: 0;
    bottom: 6rem;
    padding: 12px 24px;
    height: fit-content;
}

.summaryMainButton {
    color: white;
    &:disabled {
        color: var(--mantine-color-gray-6);
        background: var(--mantine-color-gray-7);
    }
}

.callbackButton {
    border: 1px solid var(--mantine-color-primary-4);
}

.notificationWrapper {
    padding: 0.75rem 1rem;
    border-radius: 4px;
    align-items: center;
}

.loadingBg {
    background-color: color-mix(in srgb, var(--mantine-color-primary-2), transparent 80%);
}

.defaultBg {
    background-color: color-mix(in srgb, var(--mantine-color-dark-3), transparent 90%);
}
